import { Api } from '@webapp/util/Api'
import { useTokenManager } from '@webapp/auth/TokenManager'
import { Environment } from '@webapp/util/Environment'

export function useResearchDataApi() {
    const tokenManager = useTokenManager()

    return new Api(Environment.get('RESEARCH_DATA_URL'), tokenManager.getAccessTokenAsync);
}
